module.exports = __webpack_public_path__ + "img/zxitemimg2.a8d290ae.png";